import type { AuthContext } from '@/shared/auth';
import { NotFoundView } from '@pages/Static';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

interface RouterContext {
  auth: AuthContext;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
  notFoundComponent: NotFoundView,
});
